import { TeamsPresence, TeamsPresenceWrapper } from "../models/teams";
import { GraphClients } from "../teamsClient";
import {
	getAgendaStartDateString,
	getAgendaEndDateString,
} from "@/common/helpers/timeHelper";

export const UserTeamsPictureKey = "userTeamsPictureKey";
export const UserTeamsPresenceKey = "userTeamsPresenceKey";

export const getUserProfilePicture = async (
	azureId: string
): Promise<Blob | null> => {
	try {
		return await GraphClients.instance.client.get(
			`users/${azureId}/photo/$value`
		);
	} catch {
		return null;
	}
};

export const getTeamsPresence = (azureId: string): Promise<TeamsPresence> => {
	return GraphClients.instance.client.get(`users/${azureId}/presence`);
};

export const getUserScheduleView = (contactUPN: string): Promise<any> => {
	const startDateString = getAgendaStartDateString();
	const endDateString = getAgendaEndDateString();
	const calledMethod = `/users/${contactUPN}/calendar/getSchedule`;

	const body = {
		schedules: [contactUPN],
		startTime: {
			dateTime: startDateString,
			timeZone: "UTC",
		},
		endTime: {
			dateTime: endDateString,
			timeZone: "UTC",
		},
		availabilityViewInterval: 30,
	};

	return GraphClients.instance.client.post(calledMethod, body);
};

export const getTeamsPresences = (
	azureIds: string[]
): Promise<TeamsPresenceWrapper> => {
	const presence = {
		ids: azureIds,
	};

	return GraphClients.instance.client.post(
		`communications/getPresencesByUserId`,
		presence
	);
};
